module.exports = __webpack_public_path__ + "img/3.fbdc2e15.png";